import Box from "@mui/material/Box";

type PageSectionTabLabelProps = Readonly<{
  line1: string;
  line2?: string;
}>;

export function PageSectionTabLabel({ line1, line2 }: PageSectionTabLabelProps) {
  if (!line2) {
    return (
      <Box
        component="span"
        sx={{
          display: "block",
          textAlign: "left",
          width: "100%",
          lineHeight: "20px",
          whiteSpace: "normal",
        }}
      >
        {line1}
      </Box>
    );
  }

  return (
    <Box
      component="span"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        textAlign: "left",
        width: "100%",
        lineHeight: "20px",
        whiteSpace: "normal",
      }}
    >
      <Box component="span">{line1}</Box>
      <Box component="span">{line2}</Box>
    </Box>
  );
}
